import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceBase } from '../base/base.service';
import { APP_CONFIG } from '@app/shared/config/app.config';
import { IMonitoringLogger } from '@app/shared/interface/monitoring-logger';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService extends ServiceBase {
  constructor(private readonly _http: HttpClient) {
    super(`${APP_CONFIG.serviceBaseUrl}`);
  }

  setMonitoring(data: IMonitoringLogger): any {
    return this._http.post(`${this.baseUrl}/cx/api/monitoring`, data);
  }
}
